export enum EXPANDABLE_STATES {
  IDLE = 'idle',
  EXPANDING = 'expanding',
  EXPANDED = 'expanded',
  COLLAPSING = 'collapsing',
  COLLAPSED = 'collapsed',
}

// Interfaces
export interface ElementPosition {
  left: number;
  top: number;
  width: number;
  height: number;
}

export const GROUPS_ITEMS_PER_ROW_DESKTOP = 3;
export const GROUPS_ITEMS_PER_ROW_TABLET = 2;
export const GROUPS_ITEMS_PER_ROW_MOBILE = 1;

export const GRID_HEADER_HEIGHT = 62;
export const GRID_DEFAULT_COLUMNS_NUMBER_DESKTOP = 5;
export const GRID_DEFAULT_COLUMNS_NUMBER_TABLET = 2;
export const GRID_DEFAULT_COLUMNS_NUMBER_MOBILE = 2;
export const GRID_DEFAULT_ITEMS_NUMBER_DESKTOP = GRID_DEFAULT_COLUMNS_NUMBER_DESKTOP * 2;
export const GRID_DEFAULT_ITEMS_NUMBER_TABLET = GRID_DEFAULT_COLUMNS_NUMBER_TABLET * 2;
export const GRID_DEFAULT_ITEMS_NUMBER_MOBILE = GRID_DEFAULT_COLUMNS_NUMBER_MOBILE * 2;
export const GRID_MAX_SUPPORTED_ITEMS = 10000;
export const GRID_ITEM_TITLE_HEIGHT = 40;
export const GRID_ITEM_ACTIONS_HEIGHT = 60;

export const DEBUG_ANIMATION_MULTIPLIER = 1;

export const STACKS_ANIMATION_MS = 200 * DEBUG_ANIMATION_MULTIPLIER;
export const GROUP_SELECTOR_HEADER_ITEM_ANIMATION_MS = 500 * DEBUG_ANIMATION_MULTIPLIER;

export const GRID_ITEM_ANIMATION_DURATION = 500 * DEBUG_ANIMATION_MULTIPLIER;
export const GRID_ITEM_ANIMATION_FADE_DURATION = 200 * DEBUG_ANIMATION_MULTIPLIER;
export const GRID_BACKGROUND_ANIMATION_DURATION = 450 * DEBUG_ANIMATION_MULTIPLIER;

export const LOOKUP_BAR_BASE_MARGIN_DESKTOP = 126;
export const LOOKUP_BAR_BASE_MARGIN_MOBILE = 0;

export const LOOKUP_BAR_EXPANDED_MARGIN = 222;
